import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
	providedIn: 'root',
})
export class CustomToastrService {
	constructor(private toastr: ToastrService) {}

	toasterSettings(timeOutValue?: number) {
		const commonSettings = {
			timeOut: timeOutValue ? timeOutValue : 0,
			extendedTimeOut: 0,
			tapToDismiss: false,
			enableHtml: true,
		};
		return commonSettings;
	}

	success(message: string) {
		this.toastr.success(message, '');
	}

	warning(message: string) {
		this.toastr.warning(message, '');
	}

	error(message: string) {
		this.toastr.error(message, '');
	}

	successToastr(message: string) {
		this.toastr.success(message, '', this.toasterSettings());
	}

	warningToastr(message: string) {
		this.toastr.warning(message, '', this.toasterSettings());
	}

	errorToastr(message: string, timeOutValue?: number) {
		this.toastr.error(message, '', this.toasterSettings(timeOutValue));
	}

	clear() {
		this.toastr.clear();
	}
}
